import { isPast } from "date-fns";
import { isSameDayLocal } from "./is-same-day-local";

// isSameDay from date-fns doesn't consider local timezone, use this instead
export const isPastOrTodayLocal = (date: Date): boolean => {
 if (isSameDayLocal(date, new Date())) {
   return true;
 }

  return isPast(date);
};
